import {
  Cancel,
  CheckCircle,
  InfoRounded,
  WarningRounded
} from '@mui/icons-material';
import { Alert, CircularProgress, SxProps, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  type: 'success' | 'info' | 'error' | 'warning';
  title: string;
  sx?: SxProps;
  isLoading?: boolean;
}>;

export const AlertCard: React.FC<Props> = ({
  type,
  title,
  children,
  sx,
  isLoading
}) => {
  return (
    <Alert
      variant="filled"
      severity={type}
      iconMapping={{
        success: <CheckCircle />,
        info: isLoading ? <CircularProgress size={24} /> : <InfoRounded />,
        error: <Cancel />,
        warning: <WarningRounded />
      }}
      sx={sx}
    >
      {title}
      {children && (
        <Typography variant="body2" mt={1}>
          {children}
        </Typography>
      )}
    </Alert>
  );
};
